<div class="h-full w-full overflow-auto">
  <div
    *ngIf="isSelectValid === false"
    class="text-s500 flex h-full w-full select-none flex-row items-center justify-center text-lg font-semibold"
    ><div class="w-3/5 text-center">
      {{ errorMessage || 'this chart type is not supported' }}
    </div>
  </div>

  <div
    *ngIf="isSelectValid === true && chart.isValid === false"
    class="text-r1 flex h-full select-none items-center justify-center text-lg"
    >Chart parameters are not valid</div
  >

  <div
    *ngIf="
      isSelectValid === true &&
      chart.isValid === true &&
      qData?.length === 0 &&
      (queryStatus === queryStatusEnum.New ||
        queryStatus === queryStatusEnum.Canceled)
    "
    class="text-s500 flex h-full select-none items-center justify-center text-lg font-semibold"
    >Run query to get data</div
  >

  <div
    *ngIf="
      isSelectValid === true &&
      chart.isValid === true &&
      qData?.length === 0 &&
      queryStatus === queryStatusEnum.Running
    "
    class="text-s500 flex h-full select-none items-center justify-center text-lg font-semibold"
    >Query is Running</div
  >

  <div
    *ngIf="
      isSelectValid === true &&
      chart.isValid === true &&
      qData?.length === 0 &&
      queryStatus === queryStatusEnum.Completed
    "
    class="text-s500 flex h-full select-none items-center justify-center text-lg font-semibold"
    >Query returned zero rows</div
  >

  <div
    *ngIf="
      isSelectValid === true &&
      chart.isValid === true &&
      queryStatus === queryStatusEnum.Error
    "
    class="text-r1 flex h-full select-none items-center justify-center text-lg font-semibold"
    >Query Error</div
  >

  <div
    class="flex h-full w-full"
    *ngIf="
      queryStatus !== queryStatusEnum.Error &&
      isSelectValid === true &&
      eChartsTypes.indexOf(chart.type) > -1 &&
      chart.isValid === true &&
      qData?.length > 0
    "
  >
    <m-chart-box
      [eChartInitOpts]="eChartInitOpts"
      [eChartOptions]="eChartOptions"
      [chartInstanceId]="chartInstanceId"
      style="width: 100%; height: 100%"
    ></m-chart-box>
  </div>

  <div
    class="h-full"
    *ngIf="
      queryStatus !== queryStatusEnum.Error &&
      isSelectValid === true &&
      chart.type === chartTypeEnum.Table &&
      chart.isValid === true &&
      qData?.length > 0
    "
  >
    <m-chart-table
      class="block h-full w-full"
      [isFormat]="chart.format === false ? false : true"
      [isTableHeaderWide]="isTableHeaderWide"
      [qData]="qData"
      [mconfigFields]="mconfigFields"
    ></m-chart-table>
  </div>

  <m-chart-pivot-table
    *ngIf="
      queryStatus !== queryStatusEnum.Error &&
      isSelectValid === true &&
      chart.type === chartTypeEnum.PivotTable &&
      chart.isValid === true &&
      qData?.length > 0
    "
    class="block h-full w-full"
    [qData]="qData"
    [mconfigFields]="mconfigFields"
    [chart]="chart"
    (chartPartChange)="chartPartChange.emit($event)"
  ></m-chart-pivot-table>

  <m-chart-single
    *ngIf="
      queryStatus !== queryStatusEnum.Error &&
      isSelectValid === true &&
      chart.type === chartTypeEnum.Single &&
      chart.isValid === true &&
      qData?.length > 0
    "
    [isFormat]="chart.format === false ? false : true"
    [qData]="qData"
    [mconfigFields]="mconfigFields"
    [yFieldColumn]="yFieldColumn"
  ></m-chart-single>
</div>
